var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { StyledFlex } from '../../../styles/common';
import { colors } from '../../../styles/theme';
import { StyledSecondaryButton } from '../../../styles/buttons';
export var StyledLoadMore = styled(StyledFlex)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 60px;\n  border-top: 1px solid ", ";\n"], ["\n  height: 60px;\n  border-top: 1px solid ", ";\n"])), colors.lightGrey);
export var StyledDisputesButton = styled(StyledSecondaryButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  width: auto;\n  padding: 0;\n"], ["\n  width: auto;\n  padding: 0;\n"])));
var templateObject_1, templateObject_2;
//# sourceMappingURL=subcomponents.js.map